"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationCardHeader = void 0;
const React = require("react");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const useRetailLocationAvailability_1 = require("../../../hooks/useRetailLocationAvailability");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "RetailLocationCardHeader");
const RetailLocationCardHeader = ({ retailLocation, orderType, showDetails }) => {
    const { locationImageUrl } = retailLocation;
    const available = (0, useRetailLocationAvailability_1.useRetailLocationAvailableForOrderType)(retailLocation, orderType);
    return (React.createElement("div", { className: css("", { [`-isUnavailable`]: !available }), style: {
            backgroundImage: `url("${locationImageUrl}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            position: "relative"
        } },
        React.createElement("h3", { className: css("name") }, retailLocation.title),
        available && showDetails && (React.createElement("h5", { className: css("orderDetails") },
            React.createElement(RetailLocationDetailsText, { retailLocation: retailLocation, orderType: orderType }))),
        !available && (React.createElement("h4", { className: css("unavailableHeader", {
                [`-isUnavailable`]: !available
            }) }, `${orderType} Unavailable`))));
};
exports.RetailLocationCardHeader = RetailLocationCardHeader;
const RetailLocationDetailsText = ({ retailLocation, orderType }) => {
    const { deliveryCost, minimumDeliveryAmount, orderingTimes: { averagePickupTime, averageDeliveryTime } } = retailLocation;
    if (orderType === TSalesOrderType_1.TSalesOrderType.Pickup) {
        return React.createElement("span", null,
            averagePickupTime,
            "min");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            averageDeliveryTime,
            "min -",
            " ",
            React.createElement(DeliveryCostComp, { deliveryCost: deliveryCost })),
        minimumDeliveryAmount && (React.createElement("div", { className: css("minimumAmount") },
            "minimum -",
            " ",
            React.createElement(MinimumAmountComp, { minimumDeliveryAmount: minimumDeliveryAmount })))));
};
const DeliveryCostComp = ({ deliveryCost }) => (React.createElement(Currency_1.Currency, null, deliveryCost));
const MinimumAmountComp = ({ minimumDeliveryAmount }) => React.createElement(Currency_1.Currency, null, minimumDeliveryAmount);
//# sourceMappingURL=index.js.map